import React, { FC, useEffect, useState } from "react";
import { exportXlsx, handleKeyDownEvent } from "utils/utilsLogic";
import { useAppSelector } from "../../../redux/hooks";
import Const from '../../../const.json';
import exportImg from "../../../assets/images/export.png";
import exportImg_accessibility from "../../../assets/images/export_accessibility.png";
import "./ExportToExcel.scss";

interface ExportToExcelProps {
    headers: string[];
    data: any[];
    filename?: string;
}

const ExportToExcel: FC<ExportToExcelProps> = ({ headers, data, filename = 'report' }) => {

    const { isContrast } = useAppSelector(state => state.general);
    const [icon, setIcon] = useState<any>(exportImg);

    useEffect(() => {
        setIcon(isContrast ? exportImg_accessibility : exportImg)
    }, [isContrast]);

    const downloadFunc = () => {
        exportXlsx(filename, headers, data, true, true);
    }

    return (
        <div
            className="exportToExcel"
            tabIndex={0}
            onKeyDown={(event) => handleKeyDownEvent(event, downloadFunc)}
            onClick={downloadFunc}
        >
            <span className="downloadFileLabel">{Const.downloadFile}</span>
            <img src={icon} alt={Const.iconOfDownloadFile} />
        </div>
    );
};

export default ExportToExcel;
